<template>
  <v-container id="productList" fluid class="pa-0">
    <CategoryBanner />
    <v-row>
      <GoToBanner path="Catalog" />
    </v-row>
    <v-row justify="center" align="center" class="mb-10" no-gutters>
      <div class="heading-h3">{{ category.name }}</div>
    </v-row>
    <v-row class="detail-view-container py-0" no-gutters>
      <v-col cols="12" md="2">
        <CategoryFilters @fetch-products="fetchProducts" />
      </v-col>
      <v-col cols="12" md="10">
        <!-- TODO: Pagination goes here -->
        <ProductList :products="products" />
        <CategoryPagination @fetch-products="fetchProducts" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GoToBanner from "@/components/GoToBanner";
  import ProductList from "@/components/Products/ProductList";
  import CategoryFilters from "@/components/Catalog/CategoryFilters";
  import CategoryBanner from "./CategoryBanner";
  import CategoryPagination from "./CategoryPagination";

  export default {
    name: "CategoryPage",

    computed: {
      currentSortByObjInfo() {
        return this.$store.getters.currentCategorySortByObj;
      },

      currentPointsFilterInfo() {
        return this.$store.getters.currentCategoryPointsFilter;
      },

      currentPaginationInfo() {
        return this.$store.getters.currentCategoryPaginationInfo;
      },

      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },

      categoryId() {
        return this.$validator.isString(this.$route.params.categoryId) ? parseInt(this.$route.params.categoryId) : this.$route.params.categoryId;
      },

      products() {
        return this.$store.getters.getProducts();
      },

      category() {
        return this.$store.getters.currentCategory(this.categoryId) ? this.$store.getters.currentCategory(this.categoryId) : {};
      },
    },

    components: { GoToBanner, ProductList, CategoryFilters, CategoryBanner, CategoryPagination },

    methods: {
      parsePaginationInfoToParams() {
        if (!this.$validator.isUndefined(this.currentPaginationInfo.currentPage) && !this.$validator.isUndefined(this.currentPaginationInfo.pageSize)) {
          let offset = (this.currentPaginationInfo.currentPage - 1) * this.currentPaginationInfo.pageSize;

          return `offset=${offset}&limit=${this.currentPaginationInfo.pageSize}`;
        } else {
          return "";
        }
      },

      parsePointsFilterToParams() {
        if (!this.$validator.isEmpty(this.currentPointsFilterInfo.maxPoints)) {
          return `points=${this.currentPointsFilterInfo.maxPoints}`;
        } else {
          return "";
        }
      },

      parseSortByObjToParams() {
        if (!this.$validator.isEmpty(this.currentSortByObjInfo.sortByField)) {
          if (this.currentSortByObjInfo.sortByOrder === "desc") {
            return `sort=-${this.currentSortByObjInfo.sortByField}`;
          } else {
            return `sort=${this.currentSortByObjInfo.sortByField}`;
          }
        } else {
          return "";
        }
      },

      fetchProducts() {
        let paramsString = `${this.parseSortByObjToParams()}&${this.parsePointsFilterToParams()}&${this.parsePaginationInfoToParams()}`;

        this.$store.commit("setLoadingStatus", true);
        this.$http
          .get(`/products?&category_id=${this.categoryId}&${paramsString}`)
          .then((response) => {
            this.$store.commit("addProducts", response.data.products);

            if (response.data.pagination && response.data.pagination.total) {
              this.$store.commit("setCategoryPaginationInfo", {
                total: response.data.pagination.total,
              });
            }
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: this.$formatter.getErrorMsg(error),
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          });
      },

      fetchCategories() {
        this.$http
          .get("/categories")
          .then((response) => {
            this.$store.commit("addCategories", response.data.categories);
          })
          .catch(() => {
            console.log("failed to retrieve categories");
          });
      },
    },

    created() {
      this.fetchCategories();
      this.fetchProducts();

      if (!this.$validator.isUndefined(this.categoryId)) {
        this.$store.commit("toggleCategoryFilter", this.categoryId);
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Catalog/CategoryPage.vue